import React from "react";
import {
  Button,
  Card,
  CardActionArea,
  CardMedia,
  Divider,
  Grid,
  Typography,
} from "@mui/material";

function WorkExperience({ data }) {
  return (
    <div className="pb-2 pt-2">
      <h5>Work Experience</h5>
      {data.Experiences.map((exp, idx) => {
        return (
          <>
            <div key={idx} className="pb-2">
              <Typography color="primary" variant="h6">
                Company Name {idx + 1}
              </Typography>
              <Typography variant="subtitle1" style={{ color: "#595959" }}>
                {exp.company}
              </Typography>
              <Typography color="primary" variant="h6">
                Position
              </Typography>
              <Typography variant="subtitle1" style={{ color: "#595959" }}>
                {exp.job_position}
              </Typography>
              <Typography color="primary" variant="h6">
                Start Date
              </Typography>
              <Typography variant="subtitle1" style={{ color: "#595959" }}>
                {exp.start_date}
              </Typography>
              <Typography color="primary" variant="h6">
                End Date
              </Typography>
              <Typography variant="subtitle1" style={{ color: "#595959" }}>
                {exp.is_current === true ? "Present" : exp.end_date}
              </Typography>
              <Typography color="primary" variant="h6">
                Job Description
              </Typography>
              <Typography variant="subtitle1" style={{ color: "#595959" }}>
                {exp.detail}
              </Typography>
            </div>
          </>
        );
      })}
    </div>
  );
}

export default WorkExperience;
